'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ExternalLink = undefined;

var _themeProvider = require('@spp/theme-provider');

var _ExternalLink = require('./ExternalLink');

var _ExternalLink2 = _interopRequireDefault(_ExternalLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-named-as-default */
exports.ExternalLink = _ExternalLink2.default;
exports.default = (0, _themeProvider.themer)('@spp/ui-external-link')(_ExternalLink2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-external-link/lib/cjs/index.js
 ** module id = 121
 ** module chunks = 1
 **/